import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { BackendApi, localhost } from '../config/backend-api';
import { Patient } from '../model/user/Patient';
import {
  QuestionnaireClinicalHBIResult, QuestionnaireClinicalPRISMResult,
  QuestionnaireClinicalSCCAIResult,
  QuestionnaireEORTCResult,
  QuestionnaireEQ5D5LResult,
  QuestionnaireHADSResult,
  QuestionnaireHBIResult,
  QuestionnaireIBDDiskResult,
  QuestionnaireIPAQSFResult,
  QuestionnaireMIAHCDResult,
  QuestionnaireMIAHUCResult,
  QuestionnaireMMAS8Result,
  QuestionnairePatientSCCAIResult, QuestionnairePHQ9Result, QuestionnairePRISMResult, QuestionnairePSQIResult,
  QuestionnaireSIBDQResult,
  QuestionnaireTSQMResult,
  QuestionnaireWPAIResult,
  QuestionnaireIBDQResult,
  QuestionnaireLARSResult
} from '../model/questionnaires/questionnaire-results';
import { AppState } from '../store/app.states';
import { Store } from '@ngrx/store';
import { JobModel } from '../model/job/JobModel';
import { QuestionnaireMIAHUC } from '../model/questionnaires/questionnaire-miah-uc';
import { QuestionnaireNotRead } from '../model/questionnaires/questionnaire-not-read';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { InactivePatient } from '../model/user/InactivePatient';
import { ChatMessage } from "../model/chat-message/ChatMessage";
import { Therapy } from '../model/user/Therapy';
import { BodyStat } from '../model/user/BodyStat';
import { PatientBodyStat } from '../model/user/PatientBodyStat';
import { Announcement } from '../model/announcement/Announcement';

@Injectable({
  providedIn: 'root'
})
export class DoctorService {

  constructor(private httpClient: HttpClient,
    private router: Router,
    private store: Store<AppState>) { }

  getBodyStatPatient(patientSSN: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    console.log('url:' + localhost + BackendApi.GET_BODYSTAT_PATIENT + doctorID + '/' + patientSSN);
    return this.httpClient.get<PatientBodyStat>(localhost + BackendApi.GET_BODYSTAT_PATIENT + doctorID + '/' + patientSSN);
  }

  getPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    console.log('url:' + localhost + BackendApi.GET_PATIENTS + doctorID);
    return this.httpClient.get<Patient[]>(localhost + BackendApi.GET_PATIENTS + doctorID);
  }

  getGlobalPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    console.log('url:' + localhost + BackendApi.GET_GLOBAL_PATIENTS + doctorID);
    return this.httpClient.get<Patient[]>(localhost + BackendApi.GET_GLOBAL_PATIENTS + doctorID);
  }

  // TODO: MODIFY AFTER A NEW QUESTIONNAIRE MUST BE ADDED

  getQuestionnairesClinicalSCCAI(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireClinicalSCCAIResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesClinicalHBI(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireClinicalHBIResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesClinicalPRISM(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireClinicalPRISMResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesEORTC(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireEORTCResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }
  getQuestionnairesEQ5D5L(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireEQ5D5LResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesHADS(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireHADSResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesHBI(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireHBIResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }
  getQuestionnairesIBDDisk(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireIBDDiskResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesIPAQSF(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireIPAQSFResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesMIAHCD(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireMIAHCDResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesMIAHUC(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireMIAHUCResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesMMAS8(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireMMAS8Result[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN)
      .pipe(
        map(results => results.filter(r => r.finalScore !== 999))
      );
  }

  getQuestionnairesPatientSCCAI(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnairePatientSCCAIResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesDataConsent(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireMMAS8Result[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + 'MMAS8' + '/' + doctorID + '/' + patientSSN)
      .pipe(
        map(results => results.filter(r => r.finalScore === 999))
      );
  }

  getQuestionnairesPHQ9(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnairePHQ9Result[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesPRISM(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnairePRISMResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesPSQI(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnairePSQIResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesSIBDQ(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireSIBDQResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }
  getQuestionnairesTSQM(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireTSQMResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }
  getQuestionnairesWPAI(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireWPAIResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesIBDQ(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireIBDQResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  getQuestionnairesLARS(patientSSN: string, type: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<QuestionnaireLARSResult[]>
      (localhost + BackendApi.GET_QUESTIONNAIRES + type + '/' + doctorID + '/' + patientSSN);
  }

  removePatient(patient) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    const patientEmail = patient.email;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.REMOVE_PATIENT + doctorID + '/' + patientEmail,
      null, { responseType: 'text', observe: 'response' });
  }

  getJobs(patientSSN) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<JobModel[]>(localhost + BackendApi.GET_JOBS + doctorID + '/' + patientSSN);
  }

  public editPatientClinicalProfile(email, statForm) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.EDIT_PATIENT_CLINICAL_PROFILE + doctorID + '/' + email, statForm, { responseType: 'json', observe: 'response' });
  }

  deleteNote(email: string, n: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.DELETE_NOTE + doctorID + '/' + email, n, { responseType: 'text', observe: 'response' });
  }
  deleteTherapy(email: string, n: Therapy) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.DELETE_THERAPY + doctorID + '/' + email, n, { responseType: 'text', observe: 'response' });
  }

  getClinicalPendings() {

  }

  getDoctorInfo(doctorID: string) {
    return this.httpClient.get<string>(localhost + BackendApi.GET_DOCTOR_INFO + doctorID, { responseType: 'json' });
  }

  getQuestionnaireNotRead() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    if (doctorID != null) {
      return this.httpClient.get<QuestionnaireNotRead[]>(localhost + BackendApi.GET_QUESTIONNAIRES_NOT_READ + doctorID, { responseType: 'json' })
        .pipe(
          catchError(err => {
            console.error(err);
            return throwError(`error getQuestionnaireNotRead: ${err.message}`);
          })
        );
    }
  }

  getGlobalQuestionnaireNotRead() {
    return this.httpClient.get<QuestionnaireNotRead[]>(localhost + BackendApi.GET_GLOBAL_QUESTIONNAIRES_NOT_READ, { responseType: 'json' });
  }

  getQuestionnaire(id, type) {
    return this.httpClient.get<any>(localhost + BackendApi.GET_QUESTIONNAIRE + type + '/' + id, { responseType: 'json' });
  }

  getPatient(patientSSN) {
    return this.httpClient.get<Patient>(localhost + BackendApi.GET_PATIENT + patientSSN, { responseType: 'json' });
  }

  markAsReadQuestionnaires(listQuestionnaires: any) {
    return this.httpClient.post(localhost + BackendApi.MARK_AS_READ_QUESTIONNAIRES, listQuestionnaires, { responseType: 'text', observe: 'response' });
  }

  getInactivePatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get<InactivePatient[]>(localhost + BackendApi.GET_INACTIVE_PATIENTS + doctorID, { responseType: 'json' });
  }


  //NUMBER OF ALL PATIENTS
  getAllPatientsNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_PATIENTS_NUMBER + doctorID, { responseType: 'json' });
  }
  //NUMBER OF ALL PATIENTS TELEMEDICINE
  getAllPatientsTelemedicineNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_PATIENTS_TELEMEDICINE_NUMBER + doctorID, { responseType: 'json' });
  }
  //NUMBER OF ALL PATIENTS TELEMEDICINE
  getAllPatientsStandardNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_PATIENTS_TELEMEDICINE_NUMBER + doctorID, { responseType: 'json' });
  }
  // THESE THREE SERVICES ARE NEEDED IN THE SECTION 'DOCTOR-MANAGEMENT/GENERAL-STATUS TO DISPALY IN THE DOUGHNUT CHART NUMBERS'
  // service to get all patients with pathology UC
  getAllCrohnPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_CROHN_PATIENTS + doctorID, { responseType: 'json' });
  }
  getAllCrohnPatientsNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_CROHN_PATIENTS_NUMBER + doctorID, { responseType: 'json' });
  }
  // service to get all patients with pathology Crohn
  getAllColiteUlcerosaPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_UC_PATIENTS + doctorID, { responseType: 'json' });
  }
  getAllColiteUlcerosaPatientsNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_UC_PATIENTS_NUMBER + doctorID, { responseType: 'json' });
  }
  // service to get all patients with pathology ALTRO
  getAllAltroPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_ALTRO_PATIENTS + doctorID, { responseType: 'json' });
  }
  getAllAltroPatientsNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALL_ALTRO_PATIENTS_NUMBER + doctorID, { responseType: 'json' });
  }
  // service to get all patients with pathology Crohn of a doctor
  getCrohnPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_CROHN_PATIENTS + doctorID, { responseType: 'json' });
  }
  getCrohnPatientsNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_CROHN_PATIENTS_NUMBER + doctorID, { responseType: 'json' });
  }
  // service to get all patients with pathology UC of a doctor
  getColiteUlcerosaPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_UC_PATIENTS + doctorID, { responseType: 'json' });
  }

  getColiteUlcerosaPatientsNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_UC_PATIENTS_NUMBER + doctorID, { responseType: 'json' });
  }
  // service to get all patients with pathology ALTRO of a doctor
  getAltroPatients() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALTRO_PATIENTS + doctorID, { responseType: 'json' });
  }

  getAltroPatientsNumber() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_ALTRO_PATIENTS_NUMBER + doctorID, { responseType: 'json' });
  }

  // SERVICE TO GET INACTIVE AND ACTIVE PATIENTS FOR DOCTOR
  // this service is to get all inactive patients of a doctor for the category telemedicine
  getInactiveTelemedicineDoctor() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_TELEMEDICINE_FOR_DOCTOR_PATIENTS + doctorID, { responseType: 'json' });
  }
  // this service is to get all inactive patients of a doctofor the category standard
  getInactiveStandardDoctor() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_STANDARD_FOR_DOCTOR_PATIENTS + doctorID, { responseType: 'json' });
  }
  // this service is to get all telemedicine patients of a doctor
  getTelemedicinePatientsDoctor() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_TELEMEDICINE_PATIENTS_FOR_DOCTOR + doctorID, { responseType: 'json' });
  }
  // this service is to get all standard patients of a doctor
  getStandardPatientsDoctor() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.get(localhost + BackendApi.GET_STANDARD_PATIENTS_FOR_DOCTOR + doctorID, { responseType: 'json' });
  }
  // SERVICE TO GET ALL GLOBAL ACTIVE AND INACTIVE PATIENTS
  // get all inactive telemedicine patients
  getInactiveGlobalTelemedicine() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_INACTIVE_PATIENTS_TELEMEDICINE, { responseType: 'json' });
  }
  // get all inactive standard patients
  getInactiveGlobalStandard() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_INACTIVE_PATIENTS_STANDARD, { responseType: 'json' });
  }
  // get all global telemedicine patients
  getGlobalTelemedicine() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_TELEMEDICINE, { responseType: 'json' });
  }
  // get all global standard patients
  getGlobalStandard() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_STANDARD, { responseType: 'json' });
  }
  getGlobalStandardTeleMedicineNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_STANDARD_TELEMEDICINE_NUMBER, { responseType: 'json' });
  }
  getGlobalUCCDNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_UCCDALTRO_NUMBER, { responseType: 'json' });
  }
  getGlobalUOMODOONNAALTRONumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_UOMODONNAALTRO_NUMBER, { responseType: 'json' });
  }
  getGlobalAgeNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGES_NUMBER, { responseType: 'json' });
  }
  getGlobalAgeFromUserNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGES_FROM_USER_NUMBER, dates, { responseType: 'json' });
  }

  getGlobalAgeOfDiagnosisNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_NUMBER, { responseType: 'json' });
  }
  getGlobalAgeOfDiagnosisFromUserNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_FROM_USER_NUMBER, dates, { responseType: 'json' });
  }

  getGlobalPathologyDurationNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_NUMBER, { responseType: 'json' });
  }
  getGlobalPathologyDurationFromUserNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_FROM_USER_NUMBER, dates, { responseType: 'json' });
  }

  getGlobalUCCDLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_UCCDALTRO_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }
  getGlobalUOMODOONNAALTROLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_UOMODONNAALTRO_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }
  getGlobalAgeLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGES_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }
  getGlobalAgeFromUserLoginExistsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGES_FROM_USER_LOGINEXISTS_NUMBER, dates, { responseType: 'json' });
  }

  getGlobalAgeOfDiagnosisLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }
  getGlobalAgeOfDiagnosisFromUserLoginExistsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_FROM_USER_LOGINEXISTS_NUMBER, dates, { responseType: 'json' });
  }

  getGlobalPathologyDurationLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }
  getGlobalPathologyDurationFromUserLoginExistsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_FROM_USER_LOGINEXISTS_NUMBER, dates, { responseType: 'json' });
  }

  getGlobalInterventiNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_INTERVENTI_NUMBER, { responseType: 'json' });
  }

  getGlobalInterventiLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_INTERVENTI_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }

  getGlobalActiveTherapyNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_ACTIVETHERAPY_NUMBER, { responseType: 'json' });
  }

  getGlobalActiveTherapyLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_ACTIVETHERAPY_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }

  getGlobalMalattiaInizialeMIAHNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_MIAH_NUMBER, { responseType: 'json' });
  }
  getGlobalMalattiaInizialeHBISCCAINumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_HBISCCAI_NUMBER, { responseType: 'json' });
  }

  getGlobalMalattiaInizialeMIAHLoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_MIAH_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }
  getGlobalMalattiaInizialeHBISCCAILoginExistsNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_HBISCCAI_LOGINEXISTS_NUMBER, { responseType: 'json' });
  }


  // metodo per mandare la mail di default nel momento in cui il paziente è inattivo o non si è mai collegato
  sendMailtoInactive(patientEmail: any) {
    return this.httpClient.post(localhost + BackendApi.SEND_MAIL_INACTIVE, patientEmail, { responseType: 'text', observe: 'response' });
  }
  // get never logged patients
  getNeverLogged() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED, { responseType: 'json' });
  }

  // get never logged patients
  getNeverLoggedTelemedicine() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_TELEMEDICINE, { responseType: 'json' });
  }
  // get never logged patients
  getNeverLoggedStandard() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_STANDARD, { responseType: 'json' });
  }
  // get never logged patients
  getNeverLoggedTelemedicineNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_TELEMEDICINE_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  getNeverLoggedStandardNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_STANDARD_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  // get never logged patients
  getNeverLoggedUC() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_UC, { responseType: 'json' });
  }
  // get never logged patients
  getNeverLoggedCD() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_CD, { responseType: 'json' });
  }
  getNeverLoggedAltro() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_ALTRO, { responseType: 'json' });
  }

  // get never logged patients
  getNeverLoggedUCNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_UC_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  getNeverLoggedCDNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_CD_NUMBER, { responseType: 'json' });
  }
  getNeverLoggedAltroNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_ALTRO_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  getNeverLoggedUomoNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_UOMO_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  getNeverLoggedDonnaNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_DONNA_NUMBER, { responseType: 'json' });
  }

  getNeverLoggedNoSexNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_SESSONONSPECIFICATO_NUMBER, { responseType: 'json' });
  }
  // get never logged patients

  getNeverLoggedAgeBracketsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_NEVER_LOGGED_AGEBRACKET_NUMBER, dates, { responseType: 'json' });
  }

  getNeverLoggedAgeOfDiagnosisBracketsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_NEVER_LOGGED_AGEOFDIAGNOSISBRACKET_NUMBER, dates, { responseType: 'json' });
  }

  getNeverLoggedPathologyDurationBracketsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_NEVER_LOGGED_PATHOLOGY_DURATION_BRACKET_NUMBER, dates, { responseType: 'json' });
  }


  getNeverLoggedActiveTherapyNumber(therapy: string) {
    return this.httpClient.post(localhost + BackendApi.GET_NEVER_LOGGED_THERAPY_ACTIVE_NUMBER, therapy, { responseType: 'json' });
  }

  // get never logged patients
  getNeverLoggedInterventiNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_INTERVENTI_NUMBER, { responseType: 'json' });
  }

  // get never logged patients
  getNeverLoggedNoInterventiNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_NEVER_LOGGED_NO_INTERVENTI_NUMBER, { responseType: 'json' });
  }
  /*PAZIENTI INATTIVI*/

  getInactive() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE, { responseType: 'json' });
  }
  getInactiveTelemedicineNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_TELEMEDICINE_NUMBER, { responseType: 'json' });
  }
  getInactiveStandardNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_STANDARD_NUMBER, { responseType: 'json' });
  }

  // get never logged patients
  getInactiveUCNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_UC_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  getInactiveCDNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_CD_NUMBER, { responseType: 'json' });
  }
  getInactiveAltroNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_ALTRO_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  getInactiveUomoNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_UOMO_NUMBER, { responseType: 'json' });
  }
  // get never logged patients
  getInactiveDonnaNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_DONNA_NUMBER, { responseType: 'json' });
  }

  getInactiveNoSexNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_SESSONONSPECIFICATO_NUMBER, { responseType: 'json' });
  }
  // get never logged patients

  getInactiveAgeBracketsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_INACTIVE_AGEBRACKET_NUMBER, dates, { responseType: 'json' });
  }

  getInactiveAgeOfDiagnosisBracketsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_INACTIVE_AGEOFDIAGNOSISBRACKET_NUMBER, dates, { responseType: 'json' });
  }

  getInactivePathologyDurationBracketsNumber(from: string, to: string) {
    let dates: string[] = [from, to];
    return this.httpClient.post(localhost + BackendApi.GET_INACTIVE_PATHOLOGY_DURATION_BRACKET_NUMBER, dates, { responseType: 'json' });
  }


  getInactiveActiveTherapyNumber(therapy: string) {
    return this.httpClient.post(localhost + BackendApi.GET_INACTIVE_THERAPY_ACTIVE_NUMBER, therapy, { responseType: 'json' });
  }

  getInactiveInterventiNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_INTERVENTI_NUMBER, { responseType: 'json' });
  }

  getInactiveNoInterventiNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_NO_INTERVENTI_NUMBER, { responseType: 'json' });
  }

  getInactiveMalattiaInattivaInizialeHBISCCAINumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_MALATTIA_INIZIALE_INATTIVA_HBISCCAI_NUMBER, { responseType: 'json' });
  }

  getInactiveMalattiaAttivaInizialeHBISCCAINumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_MALATTIA_INIZIALE_ATTIVA_HBISCCAI_NUMBER, { responseType: 'json' });
  }

  getInactiveMalattiaInattivaInizialeMIAHNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_MALATTIA_INIZIALE_INATTIVA_MIAH_NUMBER, { responseType: 'json' });
  }

  getInactiveMalattiaAttivaInizialeMIAHNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_INACTIVE_MALATTIA_INIZIALE_ATTIVA_MIAH_NUMBER, { responseType: 'json' });
  }


  // PAZIENTI STABILI E INSTABILI CON LA COLITE ULCEROSA, GLOBALI
  getUCStableAndUnstable() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_UC_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI CON MALATTIA DI CROHN, GLOBALI
  getCrohnStableAndUnstable() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON COLITE ULCEROSA, DIVISI PER GENERE
  getUCStableAndUnstableGender() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_GENDER_UC_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON LA MALATTIA DI CROHN, DIVISI PER GENERE
  getCrohnStableAndUnstableGender() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_GENDER_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON LA MALATTIA DI CROHN, DIVISI PER PRECEDENTI CHIRURGICI
  getCrohnStableAndUnstablePreviousSurgery() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_PREVIOUS_SURGERY_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON RETTOCOLITE ULCEROSA, DIVISI PER PRECEDENTI CHIRURGICI
  getUCStableAndUnstablePreviousSurgery() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_PREVIOUS_SURGERY_UC_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON RETTOCOLITE ULCEROSA, DIVISI PER TERAPIA ATTIVA
  getUCStableAndUnstableTherapy() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_THERAPY_UC_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON RETTOCOLITE ULCEROSA, DIVISI PER TERAPIA ATTIVA
  getCrohnStableAndUnstableTherapy() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_THERAPY_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON COLITE ULCEROSA, DIVISI PER ETA
  getUCStableAndUnstableAge() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_AGE_RANGE_UC_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON LA MALATTIA DI CROHN, DIVISI PER ETA
  getCrohnStableAndUnstableAge() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_AGE_RANGE_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON LA MALATTIA DI CROHN, DIVISI PER DURATA DELLA MALATTIA
  getCrohnStableAndUnstableDuration() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_DURATION_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON COLITE ULCEROSA, DIVISI PER DURATA DELLA MALATTIA
  getUCStableAndUnstableDuration() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_DURATION_UC_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON LA MALATTIA DI CROHN, DIVISI PER MALATTIA ATTIVA/INATTIVA INIZIALE
  getHBICrohnStableAndUnstableInitialActiveInactivePathology() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_HBI_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON COLITE ULCEROSA, DIVISI PER MALATTIA ATTIVA/INATTIVA INIZIALE
  getSCCAIUCStableAndUnstableInitialActiveInactivePathology() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_SCCAI_UC_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON LA MALATTIA DI CROHN, DIVISI PER MALATTIA ATTIVA/INATTIVA INIZIALE
  getMiahCrohnStableAndUnstableInitialActiveInactivePathology() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_MIAH_CROHN_PATIENTS, { responseType: 'json' });
  }
  // PAZIENTI STABILI E INSTABILI, CON COLITE ULCEROSA, DIVISI PER MALATTIA ATTIVA/INATTIVA INIZIALE
  getMiahUCStableAndUnstableInitialActiveInactivePathology() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_MIAH_UC_PATIENTS, { responseType: 'json' });
  }
  getStableUnstableFeatures() {
    return this.httpClient.get(localhost + BackendApi.GET_STABLE_AND_UNSTABLE_FEATURES, { responseType: 'json' });
  }
  // SCORE PATIENT-CLINICAL-SCCAI/PRISM COMPARISONS
  getClinicalPatientUCComparisons() {
    return this.httpClient.get(localhost + BackendApi.GET_UC_COMPARISONS, { responseType: 'json' });
  }
  // SCORE PATIENT-CLINICAL-HBI/PRISM COMPARISONS
  getClinicalPatientCDComparisons() {
    return this.httpClient.get(localhost + BackendApi.GET_CD_COMPARISONS, { responseType: 'json' });
  }
  // SCORE PATIENT-CLINICAL SCCAI-HBI/PRISM COMPARISONS
  getClinicalPatientUCCDComparisons() {
    return this.httpClient.get(localhost + BackendApi.GET_UC_CD_COMPARISONS, { responseType: 'json' });
  }

  //metodo che ritorna il numero totale di questionari compilati per tipologia
  getGlobalQuestionnairesForTypeNumber() {
    return this.httpClient.get(localhost + BackendApi.GET_GLOBAL_QUESTIONNAIRES_FOR_TYPE_NUMBER, { responseType: 'json' });
  }

  // Metodo utilizzato per ricevere i dati per la dashboard dei questionari
  getQuestionnairesStats() {
    return this.httpClient.get(localhost + BackendApi.GET_QUESTIONNAIRES_STATS, { responseType: 'json' });
  }
  //media score questionario gradimento
  getQuestionnaireGradimentoScoreAVG() {
    return this.httpClient.get(localhost + BackendApi.GET_QUESTIONNAIRE_GRADIMENTO_SCORE_AVG, { responseType: 'json' });
  }
  //suggerimenti dal questionario di gradimento
  getQuestionnaireGradimentoSuggerimenti() {
    return this.httpClient.get(localhost + BackendApi.GET_QUESTIONNAIRE_GRADIMENTO_SUGGERIMENTI, { responseType: 'json' });
  }


  // Metodo utilizzato per ricevere i dati per la dashboard dei questionari
  getQuestionnairesTotal() {
    return this.httpClient.get(localhost + BackendApi.GET_QUESTIONNAIRES_TOTAL, { responseType: 'json' });
  }
  // Metodo utilizzato per ricevere i dati per la dashboard dei questionari
  getQuestionnairesTotalFemale() {
    return this.httpClient.get(localhost + BackendApi.GET_QUESTIONNAIRES_TOTAL_FEMALE, { responseType: 'json' });
  }
  // Metodo utilizzato per ricevere i dati per la dashboard dei questionari
  getQuestionnairesTotalMale() {
    return this.httpClient.get(localhost + BackendApi.GET_QUESTIONNAIRES_TOTAL_MALE, { responseType: 'json' });
  }
  // Metodo utilizzato per ricevere i dati per la dashboard dei questionari
  getQuestionnairesTotalPatients() {
    return this.httpClient.get(localhost + BackendApi.GET_PATIENTS_TOTAL, { responseType: 'json' });
  }
  // Metodo utilizzato per ricevere i dati per la dashboard dei questionari
  getAverageQuestionnairesPerPatient() {
    return this.httpClient.get(localhost + BackendApi.GET_AVERAGE_QUESTIONNAIRES_PER_PATIENT, { responseType: 'json' });
  }
  // Metodo utilizzato per ricevere la media di ritenzione dei pazienti
  getAvgRetentionTime() {
    return this.httpClient.get(localhost + BackendApi.GET_AVG_RETENTION_TIME, { responseType: 'json' });
  }
  // eta media dei pazienti, per sesso
  getEtaMediaGender() {
    return this.httpClient.get(localhost + BackendApi.GET_ETA_MEDIA_PER_SESSO, { responseType: 'json' });

  }
  // metodo utilizzato per salvare sul server un messaggio dalla chat
  sendMessage(textSend: string, recipientEmail) {
    // return new Observable<any>();
    const user = JSON.parse(localStorage.getItem('user'));
    const mess = new ChatMessage(recipientEmail, user.email, textSend);
    return this.httpClient.post(localhost + 'private/chat', mess, { responseType: 'text', observe: 'response' });
  }

  sendAnnouncement(textSend: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    const text = new Announcement(textSend);
    return this.httpClient.post(localhost + 'private/doctor/send-announcement/' + doctorID, text, { responseType: 'text', observe: 'response' });
  }

  getAnnouncements() {
    return this.httpClient.get<Announcement[]>(localhost + 'private/get-announcements');
  }

  // metodo che restituisce la chat tra il paziente e il dottore.
  getChatMessages(patientEmail) {
    // return new Observable<any>();
    // const user = JSON.parse(localStorage.getItem('user'));
    return this.httpClient.get<ChatMessage[]>(localhost + 'private/chat/' + patientEmail);
  }

  getLastMessages() {
    return this.httpClient.get<ChatMessage[]>(localhost + 'private/chat/last-messages');
  }

  sendFile(file: any, recipientEmail) {
    const formData = new FormData();
    formData.append('multiFile', file);
    const options = { params: new HttpParams().set('Content-Type', 'multipart/form-data') }
    /*let options = new HttpParams().set('Content-Type', 'multipart/form-data'); // create params object
    options = options.append('responseType', 'text'); // add a new param, creating a new object
    options = options.append('observe', 'response')*/
    return this.httpClient.post(localhost + 'private/chat/' + recipientEmail + '/uploadFile', formData, options);//{params: options});
  }

  getFile(patientEmail: string, id: string) {
    return this.httpClient.get(localhost + 'private/chat/' + patientEmail + '/' + id, { responseType: 'blob' });
  }

  postClinicalDataFile(file: any) {
    return this.httpClient.post(localhost + 'private/clinicalData/uploadFile', file.default, { responseType: 'text', observe: 'response' });
  }

  setNewBirthdate(date: string, patientEmail: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient.post(localhost + BackendApi.SET_NEW_BIRTHDATE + doctorID + '/' + patientEmail, date, { responseType: 'text' });

  }

  getLastAnnouncement() {
    return this.httpClient.get<Announcement>(localhost + 'private/get-last-announcement');
  }

  getCategoryPatient(ssn: string) {
    return this.httpClient.post(localhost + 'private/get-category-patient', ssn, { responseType: 'text' });
  }

  getCountByTypeLARS() {
    return this.httpClient.get(localhost + 'private/patient/getCountByType/HBI', { responseType: 'text' });
  }

  // metodo per mandare la mail di default nel momento in cui il paziente è inattivo o non si è mai collegato
  sendEmailToUCOtherPatinets() {
    return this.httpClient.post(localhost + BackendApi.SEND_MAIL_UC_OTHER_PATINTS, {}, { responseType: 'text', observe: 'response' });
  }

  getDataAnalyses() {

    console.log(localhost + 'get-analyses-data');
    return this.httpClient.get(localhost + BackendApi.GET_DATA_ANALYSES, { responseType: 'json' });
  }
  getAllPatientsData() {
    console.log(localhost + 'get-all-patients-data');
    return this.httpClient.get(localhost + BackendApi.GET_ALL_PATIENTS_DATA, { responseType: 'json' });
  }

  getSixMonthsQuestData() {
    console.log(localhost + 'get-six-months-quest-data');
    return this.httpClient.get(localhost + BackendApi.GET_SIX_MONTHS_QUEST_DATA, { responseType: 'json' });
  }
}

